<template>
  <div class="row">
    <div class="course_detail">
      <div class="course_name pull-left">{{ course && course.name }}</div>
    </div>
    <div class="course_video">
      <iframe
        src="https://www.youtube.com/embed/mzTBR0IXBhA"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        style="width: 100%"
      />
    </div>

    <div class="col-12">
      <div
        v-if="groups && groups.length >0"
        class="row">
        <div
          v-for="(group, key, index) in groups"
          :key="group.id"
          class="body_lesson">
          <div
            class="group_lesson_name"
            @click="onClickLessonGroup(key)">
            {{ group && group.description }}
            <div class="expand-icon">
              <i
                :class="{'fa': true, 'fa-caret-down': expanded === key, 'fa-caret-up': expanded !== key}"
              />
            </div>
          </div>
          <b-collapse
            :id="'collapse-' + index"
            :visible="expanded === key"
            class="mt-2">
            <div v-if="group.lessons && group.lessons.length > 0">
              <div
                v-for="lesson in group.lessons"
                class="group_lesson_sesson"
                @click="playVideo(lesson.id)">
                <div class="sesson_name">
                  <i class="fa fa-play-circle"/>
                  {{ lesson && lesson.name }}
                </div>
                <div
                  v-if="!is_buy"
                  class="sesson_type">
                  <span
                    v-if="lesson.free_view === 1"
                    class="bg-green text-white">Xem miễn phí</span>
                  <span
                    v-if="lesson.free_view !== 1"
                    class="bg-defaut text-white">Mua khóa học</span>
                </div>
                <div class="sesson_time">{{ lesson && lesson.duration }}</div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>

    <div
      v-if="course"
      class="course_detail mt-3">
      <table class="table">
        <tbody>
        <tr>
          <td>
            <i class="fa fa-graduation-cap"/> Giảng viên
          </td>
          <td>{{ course.author }}</td>
        </tr>
        <tr>
          <td>
            <i class="fa fa-clock-o"/> Thời lượng
          </td>
          <td>{{ course.duration }}</td>
        </tr>
        <tr>
          <td>
            <i class="fa fa-thumbs-o-up"/> Likes
          </td>
          <td>{{ course.nr_view }}</td>
        </tr>
        <tr>
          <td>
            <i class="fa fa-star-o"/> Rating
          </td>
          <td>8225</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="course_detail mt-2">
      <div class="course_name bg-dark text-white">Giới thiệu</div>
      <!--      <div class="col-12 gioi_thieu">{{ course && course.description }}</div>-->
      <div class="panel-wrapper">
        <div
          class="panel_read_more"
          v-html="description"/>
        <button
          v-if="sliding && course.description && course.description.length >= 250"
          class="show_read_mode btn_read_mode"
          @click="onSlideStart()">Xem chi tiết
        </button>
        <button
          v-if="!sliding"
          class="show_read_mode btn_read_mode"
          @click="onSlideEnd()">Rút gọn
        </button>
        <div class="fade"/>
      </div>
    </div>
    <div class="my-card">
      <div class="header-card">
        <div class="header-card-left pull-left">KHOÁ HỌC TƯƠNG TỰ</div>
        <div class="header-card-right pull-right">
          <router-link to="/course">Xem thêm</router-link>
        </div>
        <div class="clearfix"/>
      </div>
      <div class="col-12">
        <flickity
          v-if="products && products.length > 0"
          ref="flickity"
          :options="flickityOptions"
          class="flickity">
          <div
            v-for="product in products"
            class="card carousel-cell w-75">
            <course-item-2 :item="product"/>
          </div>
        </flickity>
      </div>
    </div>
    <div
      v-if="is_login && !is_buy"
      class="buy-course container">
      <div>
        <div>Giá</div>
        <div>{{ course && course.cost }} đ</div>
      </div>
      <button
        class="btn btn-muangay"
        @click="showDialog()">Mua khóa học
      </button>
    </div>
  </div>
</template>

<script>
  import rf from "../../communicate/RequestFactory";
  import {warnToaster} from "../../services/ErrorHandler";
  import Flickity from "vue-flickity";
  import CourseItem2 from "./CourseItem2";
  import PaymentMethodCourseDialog from "./PaymentMethodCourseDialog";
  import {isLoggedIn} from '../../services/authService'

  export default {
    name: "CourseDetail",
    components: {
      CourseItem2,
      Flickity,
      PaymentMethodCourseDialog
    },
    data() {
      return {
        course: {},
        groups: [],
        products: [],
        description: '',
        sliding: true,
        id: this.$route.params.id,
        expanded: 0,
        is_login: isLoggedIn(),
        flickityOptions: {
          initialIndex: 2,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          freeScroll: true,
          groupCells: 2,
          autoPlay: 3000
        },
        is_buy: false
      };
    },

    watch: {
      $route(to, from) {
        this.loadDetailCourse(to.params.id);
      }
    },

    mounted() {
      this.is_login = isLoggedIn();

      this.loadDetailCourse(this.id);
    },

    methods: {
      onSlideStart() {
        this.sliding = false;
        this.description = this.course.description;
      },

      onSlideEnd() {
        this.sliding = true;
        this.description = this.course.description ? this.course.description.substring(0, 250) + '...' : '';
      },

      loadDetailCourse(course_id) {
        rf.getRequest("CourseRequest")
          .getCourseDetail(course_id)
          .then(res => {
            this.course = res.data.course;
            this.groups = res.data.groups;
            this.products = res.data.products;
            this.is_buy = res.data.course.is_buy === 1;
            this.description = this.course.description ? this.course.description.substring(0, 250) + '...' : '';
          })
          .catch(err => {
            warnToaster(err.message);
          });
      },

      playVideo(lesson_id) {
        this.$router.push({path: `/lesson/${lesson_id}?course_id=${this.id}`});
      },

      showDialog() {
        sessionStorage.setItem("course", JSON.stringify(this.course));
        this.$router.push({path: `/course-payment`});
      },

      onClickLessonGroup(key) {
        if (this.expanded === key) {
          this.expanded = null;
        } else {
          this.expanded = key;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }

  .buy-course {
    position: fixed;
    padding: 16px;
    bottom: 0;
    background-color: white;
    width: 100%;
    text-align: center;
    z-index: 1000;

    > div {
      margin-bottom: 30px;

      > div {
        &:first-child {
          float: left;
          font-weight: bold;
          font-size: 16px;
        }

        &:last-child {
          float: right;
          color: red;
          font-weight: bold;
          font-size: 16px;
        }
      }
    }

    button {
      width: 100%;
    }
  }

  .course_detail {
    width: 100%;
    background: #fff;
  }

  .course_name {
    padding: 10px 15px;
    font-size: 1rem;
    text-transform: uppercase;
  }

  .course_video {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }

  .header_lesson {
    display: flex;
    width: 100%;
    padding: 10px 0;
    background: #efefef;
    font-size: 0.9rem;
  }

  .header_lesson .header_lesson_left {
    width: 70%;
    padding-left: 10px;
    border-right: 1px dashed #d2d6de;
    font-weight: bold;
  }

  .header_lesson .header_lesson_right {
    text-align: right;
    width: 30%;
    padding-right: 10px;
    font-weight: bold;
  }

  .body_lesson {
    width: 100%;
  }

  .group_lesson_name {
    font-size: 1rem;
    font-weight: bold;
    padding: 10px;
    background-color: #efefef;
    cursor: pointer;
    position: relative;
    margin-bottom: 5px;

    .expand-icon {
      position: absolute;
      right: 24px;
      top: 8px;
    }
  }

  .group_lesson_sesson {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #efefef;
    padding: 10px 0;
    float: left;
  }

  .group_lesson_sesson .sesson_name {
    width: 65%;
    padding-left: 3px;
  }

  .group_lesson_sesson .sesson_type {
    width: 25%;
  }

  .group_lesson_sesson .sesson_type span {
    padding: 4px 6px;
    border-radius: 15px;
    font-size: 0.6rem;
  }

  .group_lesson_sesson .sesson_time {
    width: 10%;
  }

  .fa-play-circle {
    color: darkgrey;
    font-size: 1rem;
  }

  .course_detail .table th,
  .course_detail .table td {
    font-size: 1rem;
    padding-left: 10px;
  }

  .form_register {
    width: 100%;
    background-color: #fff;
    margin-top: 10px;
    box-shadow: #efefef;
  }

  .mt-2 {
    margin-top: 10px;
  }

  .fr_form {
    padding: 10px;
  }

  .fr_form label {
    font-size: 0.9rem;
  }

  .payment_method_body {
    margin: 10px 0;
    background-color: #efefef;
    padding: 10px;
  }

  .payment_method_body p {
    margin-bottom: 5px;
    font-size: 0.9rem;
  }

  .gioi_thieu {
    font-size: 0.9rem;
    padding: 10px;
    line-height: 20px;
    white-space: pre-line;
  }

  .btn_read_mode {
    color: #000;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    padding: 0.5em;
    text-decoration: none;
    width: 100%;
  }

  .show_read_mode, .hide_read_mode {
    position: absolute;
    bottom: 0em;
    z-index: 10;
    text-align: center;
  }

  .show_read_mode:target ~ .panel_read_more {
    max-height: 2000px;
    font-size: 14px;
  }

  .show:target ~ .fade {
    margin-top: 0;
  }

  .panel_read_more {
    position: relative;
    width: 100%;
    font-size: 15px;
    overflow: hidden;
    transition: max-height .5s ease;
    white-space: pre-line;
    padding: 16px 16px 40px;
  }

  .panel-wrapper {
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/components/course/CourseDetail.vue